//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { dicOption } from '@/views/visual/dataScreen/js/option/config';
export default {
  data: function data() {
    return {
      dicOption: dicOption
    };
  },
  inject: ["main"]
};